<span *ngIf="isLoading$ | async">
  <app-preloader [isFullPreloader]="true" />
</span>
<section class="page-title-area">
  <div class="container">
    <div class="page-title-content text-center">
      <h2>Success Stories</h2>
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li>Success Stories</li>
      </ul>
    </div>

    <div style="padding: 0; margin: 5px; color: #002f6c">
      <button
        type="button"
        routerLink="/add-success-story"
        class="button btn btn-primary btn-outline-light btn-lg">
        Add Your Success Story
      </button>
    </div>
  </div>

  <div class="shape-img1">
    <img src="assets/img/shape/shape1.svg" alt="image" />
  </div>
  <div class="shape-img2">
    <img src="assets/img/shape/shape2.png" alt="image" />
  </div>
  <div class="shape-img3">
    <img src="assets/img/shape/shape3.png" alt="image" />
  </div>
</section>

<section class="projects-area pt-0 pb-70">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-4 col-md-6 my-2"
        *ngFor="let singleProjectsContent of singleProjectsBox">
        <div
          class="single-projects-box"
          [routerLink]="singleProjectsContent.link">
          <div class="image">
            <img
              [src]="singleProjectsContent.img"
              alt="image"
              [class]="singleProjectsContent.imgClass" />

            <a class="link-btn">
              <i [class]="singleProjectsContent.icon"></i>
            </a>
          </div>

          <div class="content">
            <h3>
              <a *ngIf="singleProjectsContent.link.indexOf('http') < 0">{{
                singleProjectsContent.title
              }}</a>
              <a
                *ngIf="singleProjectsContent.link.indexOf('http') >= 0"
                target="_blank"
                [innerHTML]="singleProjectsContent.title"></a>
            </h3>
            <span>{{ singleProjectsContent.subTitle }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-lg-4 col-md-6 my-2"
        *ngFor="let story of stories$ | async; index as i">
        <div class="single-projects-box" (click)="redirect(story.id)">
          <div class="image">
            <img
              [src]="story?.cover_image"
              (error)="onImageError($event)"
              alt="No Image Found"
              width="300"
              height="300" />
            <a class="link-btn"><i class="bx bx-plus"></i></a>
          </div>
          <div class="content">
            <h5>
              <a class="link-btn">{{ story.title }}</a>
            </h5>
            <span>
              {{ story?.short_description | slice: 0 : 150 }}
              {{ story?.short_description?.length > 150 ? '...' : '' }}
            </span>
          </div>
        </div>
      </div>
      <span *ngIf="isLoadingStories$ | async">
        <app-preloader [isFullPreloader]="false" />
      </span>
    </div>
  </div>
</section>
